<div *ngIf="!configMode" class="non-config-mode-container sales-by-product-widget-component">
    <p *ngIf="eventNotAvailable" class="the-event-is-no-longer-available centered-text">
        <span translate>THE_EVENT_IS_NO_LONGER_AVAILABLE</span>
    </p>
    <ng-container *ngIf="isLoaded">
        <div class="event-name centered-text">{{event?.name}}</div>
        <div *ngIf="isPresentationTotal" class="aza-pa-primary-color total-sum centered-text">{{totalText}}</div>
        <azavista3-apexcharts-wrapper *ngIf="!isPresentationTotal && definition.data" #displayModeChart
            [series]="series" [labels]="labels" [type]="chart.type" [width]="chart.width" [height]="chart.height"
            (dataPointSelected)="onDataPointSelected($event)">
        </azavista3-apexcharts-wrapper>
    </ng-container>
</div>

<div *ngIf="configMode" class="config-mode-container sales-by-product-widget-component">
    <div class="settings-container aza-pa-flex-column">
        <div *ngIf="!isLoaded" class="widget-loading-container">
            <span translate class="widget-loading">LOADING</span>
        </div>
        <div class="setting-item">
            <div class="aza-pa-flex-row">
                <div *ngIf="event" class="aza-pa-flex-row">
                    <span translate>EVENT</span>:
                    <span>{{event.name}}</span>
                </div>
                <azavista-button *ngIf="!isEventPredefined && isLoaded" (click)="onSelectEvent()">
                    <span translate>SELECT_EVENT</span>
                </azavista-button>
            </div>
        </div>
        <div class="setting-item aza-pa-flex-column">
            <mat-form-field>
                <mat-label>
                    <span translate>PRESENTATION</span>
                </mat-label>
                <mat-select (selectionChange)="presentationTypeChanged($event.value)"
                    [(value)]="definitionSettings.local.presentationType">
                    <mat-option value='bar'>Bar</mat-option>
                    <mat-option value='donut'>Donut</mat-option>
                    <mat-option value='total'>Total</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="setting-item">
            <azavista-input-field *ngIf="fields?.products" [field]="fields.products" [value]="fields.productsValue"
                (valueChanged)="onProductsChanged($event)" [label]="'PRODUCTS' | translate" [editMode]="true"
                [fullWidth]="true">
            </azavista-input-field>
        </div>
    </div>
</div>
